module.exports = __webpack_public_path__ + "static/media/rotate360.2f43faa3.svg";